const addPropertyToObject = (arr, key, items) => {
  arr.forEach((item, index) => {
    item[key] = items[index]
  })

  return arr
}

export default addPropertyToObject
